import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ roles, children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex justify-center py-32" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-blue-600" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
